import { Link } from 'react-router-dom';

export const Footer = () => (
  <footer className="bg-rich_black-500 text-white py-16">
    <div className="container mx-auto px-6">
      {/* Logo and Brand */}
      <div className="mb-12 pb-8 border-b-4 border-gray-700">
        <div className="flex items-center gap-4">
          <img
            src="/CRPTrainingDirectLogo.png"
            alt="CPR Training Direct Logo"
            className="h-16 w-auto"
          />
          <div>
            <h2 className="font-display text-2xl font-bold uppercase tracking-wide text-white">CPR Training Direct</h2>
            <p className="font-body text-gray-400 text-sm mt-1">Professional CPR Certification in Orlando & Atlanta</p>
          </div>
        </div>
      </div>

      {/* Footer Grid - 3 columns on desktop, 2 on tablet, 1 on mobile */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-8">

        {/* Quick Links */}
        <div>
          <h3 className="font-display text-lg font-bold uppercase tracking-wide mb-6 text-white border-b-4 border-amaranth_purple-500 pb-2 inline-block">Quick Links</h3>
          <ul className="space-y-3">
            <li>
              <Link to="/courses" className="font-body text-gray-300 hover:text-amaranth_purple-400 transition-colors hover:translate-x-1 inline-block">
                All Courses
              </Link>
            </li>
            <li>
              <Link to="/book" className="font-body text-gray-300 hover:text-amaranth_purple-400 transition-colors hover:translate-x-1 inline-block">
                Book a Class
              </Link>
            </li>
            <li>
              <Link to="/contact" className="font-body text-gray-300 hover:text-amaranth_purple-400 transition-colors hover:translate-x-1 inline-block">
                Contact
              </Link>
            </li>
          </ul>
        </div>

        {/* Legal */}
        <div>
          <h3 className="font-display text-lg font-bold uppercase tracking-wide mb-6 text-white border-b-4 border-amaranth_purple-500 pb-2 inline-block">Legal</h3>
          <ul className="space-y-3">
            <li>
              <Link to="/legal/privacy" className="font-body text-gray-300 hover:text-amaranth_purple-400 transition-colors hover:translate-x-1 inline-block">
                Privacy Policy
              </Link>
            </li>
            <li>
              <Link to="/legal/terms" className="font-body text-gray-300 hover:text-amaranth_purple-400 transition-colors hover:translate-x-1 inline-block">
                Terms of Service
              </Link>
            </li>
            <li>
              <Link to="/legal/accessibility" className="font-body text-gray-300 hover:text-amaranth_purple-400 transition-colors hover:translate-x-1 inline-block">
                Accessibility
              </Link>
            </li>
          </ul>
        </div>

        {/* Contact Info */}
        <div>
          <h3 className="font-display text-lg font-bold uppercase tracking-wide mb-6 text-white border-b-4 border-amaranth_purple-500 pb-2 inline-block">Contact Info</h3>

          {/* Service Areas */}
          <div className="mb-5">
            <p className="font-mono font-bold uppercase tracking-wide text-white text-sm mb-1">Service Areas</p>
            <p className="font-body text-gray-300 text-sm">Orlando, FL &amp; Atlanta, GA</p>
          </div>

          {/* Contact CTA */}
          <div>
            <Link
              to="/contact"
              className="font-mono font-bold uppercase tracking-wide text-amaranth_purple-400 text-sm hover:text-white transition-colors"
            >
              Contact Us &rarr;
            </Link>
          </div>
        </div>
      </div>

      {/* Copyright & Designer Credit - Single Row */}
      <div className="border-t-4 border-gray-700 pt-8 mt-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          {/* Copyright - Left Side */}
          <p className="font-mono text-gray-400 text-sm uppercase tracking-wide">
            &copy; {new Date().getFullYear()} CPR Training Direct. All rights reserved.
          </p>

          {/* KG ProDesign Credit - Right Side */}
          <a
            href="https://kgprodesign.com"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 hover:opacity-80 transition-opacity duration-200"
          >
            <img
              src="/KGProDesign_wht.png"
              alt="KG ProDesign Logo"
              className="h-6"
            />
            <span className="font-mono text-xs text-gray-500 uppercase tracking-wide">
              Designed by KG ProDesign
            </span>
          </a>
        </div>
      </div>
    </div>
  </footer>
);